import React from 'react';
import packageInfo from '../../../package.json';

export default () => {
  return <>{packageInfo.version}</>;
};
